import LTR from "@brand-icons/ploom/ui-eye-open/ui-eye-open-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiEyeOpenIcon = iconFactory("UiEyeOpenIcon", LTR);
